import { gql } from '@apollo/client';

export const DELETE_COFFEE_MATCH = gql`
  mutation DeleteCoffeeMatch($matchId: Float!) {
    deleteCoffeeMatch(matchId: $matchId)
  }
`;
